import { Component, OnInit, ViewChild } from "@angular/core";
import { FacilityService } from "../../services/administration/facilities/facilities.service";
import { ActivatedRoute, Router } from "@angular/router";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { IFacilityData } from "../../interfaces/administration/facilityData";

@Component({
  selector: "edit-facility-component",
  templateUrl: "./edit-facility.component.html",
  styles: [
    `
      .button-container {
        display: flex !important;
        justify-content: space-between !important;
      }
    `,
  ],
})
export class EditFacilityComponent implements OnInit {
  title = "";
  public facilityForm: FormGroup;
  public validationMessages: string[] = [];
  public facility: IFacilityData | undefined;
  public isLoading: boolean = false;

  constructor(
    private service: FacilityService,
    private router: Router,
    private route: ActivatedRoute,
    private fb: FormBuilder
  ) {
    this.facilityForm = this.fb.group({
      name: ["", Validators.required],
      entraName: ["", Validators.required],
      id: [""],
    });
  }

  ngOnInit(): void {
    this.loadFacility();
  }

  loadFacility() {
    this.isLoading = true;
    let id = this.route.snapshot.params["id"];
    this.service.getFacility(id).subscribe((data) => {
      this.facility = data;
      this.facilityForm.setValue({
        name: this.facility.name,
        entraName: this.facility.entraName,
        id: this.facility.id,
      });
      this.title = "Edit facility: " + this.facility.name;
      this.isLoading = false;
    });
  }

  onSubmit() {
    this.validationMessages = this.service.validate(this.facilityForm);
    if (this.validationMessages.length > 0) {
      //smooth scroll to top
      window.scrollTo({ top: 0, behavior: "smooth" });
      return;
    }
    this.validationMessages = [];

    if (this.facilityForm.valid) {
      let facility: IFacilityData = this.facilityForm.value;
      this.service.editFacility(facility).subscribe((result) => {
        if (result) {
          this.loadFacility();
        }
      });
    }
  }

  cancel() {
    this.router.navigate(["/administration/facilities"]);
  }
}
